import React from 'react';
import { MoreHorizontal, Pencil, Key, Ban, Trash2 } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../../../../components/ui/custom-dropdown-menu';
import { Button } from '../../../../components/ui/button';
import type { PlatformUser } from '../../types/user';

interface UserActionsMenuProps {
  user: PlatformUser;
  currentUser: PlatformUser;
  onEdit: (user: PlatformUser) => void;
  onResetPassword: (userId: string) => void;
  onToggleStatus: (userId: string, isDisabled: boolean) => void;
  onDelete: (userId: string) => void;
}

export const UserActionsMenu: React.FC<UserActionsMenuProps> = ({
  user,
  currentUser,
  onEdit,
  onResetPassword,
  onToggleStatus,
  onDelete,
}) => {
  const isDisabled = user.status === 'inactive';
  const isSelf = user.id === currentUser.id;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger>
        <Button variant="ghost" className="h-8 w-8 p-0 -mr-2 relative">
          <MoreHorizontal className="h-4 w-4" />
          <span className="sr-only">Open menu</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="start" className="w-[200px]">
        <DropdownMenuItem
          onClick={() => !isSelf && onEdit(user)}
          className={`cursor-pointer ${isSelf ? 'opacity-50 pointer-events-none' : ''}`}
        >
          <Pencil className="mr-2 h-4 w-4" />
          Edit
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => !isSelf && onResetPassword(user.id)}
          className={`cursor-pointer ${isSelf ? 'opacity-50 pointer-events-none' : ''}`}
        >
          <Key className="mr-2 h-4 w-4" />
          Reset Password
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => !isSelf && onToggleStatus(user.id, !isDisabled)}
          className={`cursor-pointer ${isSelf ? 'opacity-50 pointer-events-none' : ''}`}
        >
          <Ban className="mr-2 h-4 w-4" />
          {isDisabled ? 'Enable' : 'Disable'} User
        </DropdownMenuItem>
        <DropdownMenuItem
          onClick={() => !isSelf && onDelete(user.id)}
          className={`cursor-pointer text-red-600 ${isSelf ? 'opacity-50 pointer-events-none' : ''}`}
        >
          <Trash2 className="mr-2 h-4 w-4" />
          Delete
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}; 